// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "groupOrder-1qwFl";
var _4 = "header-y-6y1";
var _5 = "container-iiW_p";
var _6 = "flight-2tRsr";
var _7 = "passengers-FLDov";
var _8 = "passenger-1gvOw";
var _9 = "addPassenger-2HM3y";
var _a = "editPassenger-2IaAU";
var _b = "error-11J45";
var _c = "passenger__label-buP06";
var _d = "passengerValue-1SiR_";
var _e = "errorHint-2zSHw";
var _f = "checkbox-3iM0V";
var _10 = "add-1vkbS";
var _11 = "addIcon-gl4HB";
var _12 = "checkboxColor-_Iupa";
var _13 = "checked-11k_4";
var _14 = "notifications-A_7vi";
var _15 = "notification__item-OMyDq";
var _16 = "addButton-3BhLv";
var _17 = "segment-1TVek";
export { _1 as "__esModule", _2 as "mobile", _3 as "groupOrder", _4 as "header", _5 as "container", _6 as "flight", _7 as "passengers", _8 as "passenger", _9 as "addPassenger", _a as "editPassenger", _b as "error", _c as "passenger__label", _d as "passengerValue", _e as "errorHint", _f as "checkbox", _10 as "add", _11 as "addIcon", _12 as "checkboxColor", _13 as "checked", _14 as "notifications", _15 as "notification__item", _16 as "addButton", _17 as "segment" }
export default { "__esModule": _1, "mobile": _2, "groupOrder": _3, "header": _4, "container": _5, "flight": _6, "passengers": _7, "passenger": _8, "addPassenger": _9, "editPassenger": _a, "error": _b, "passenger__label": _c, "passengerValue": _d, "errorHint": _e, "checkbox": _f, "add": _10, "addIcon": _11, "checkboxColor": _12, "checked": _13, "notifications": _14, "notification__item": _15, "addButton": _16, "segment": _17 }
